import i18n from "i18next";
import { initReactI18next } from 'react-i18next'
// import $ from 'jquery';
// import translationEn from './locales/en/translationEn.json'
import translationPT from './locales/pt/translationPT.json'
// import translationAr from './locales/ar/translationAr.json'

import * as OverrideLocals from './locales/LocalOverride.js'

//the translations
const resources = {
  
  en: {
    translation: OverrideLocals.OverrideLocalEn()
  },
  pt: {
    translation: translationPT
  },
  ar: {
    translation: OverrideLocals.OverrideLocalAr()
  }
};


let language = "en";
if (localStorage.getItem("language") !== null) {
  if (localStorage.getItem("language") === "ar")
    language = "ar";
  else
    language = "en";
}
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: language,
    keySeparator: false, // we do not use keys in form messages.welcome
    interpolation: {
      escapeValue: false //react already safes from xss
    }
  })



export default i18n;